<template>
  <div class="container-fluid" @save="saveDocument" style="height: 100vh;width:100%">
    <div class="btn-toolbar d-flex justify-content-between mt-2 mb-2">
      <button @click="saveDocument" class="btn btn-primary">Speichern</button>
      <button @click="createHtmlComponent" class="btn btn-secondary">Komponente</button>
      <button @click="openDocList" class="btn btn-secondary">Zurück</button>
      <div class="input-group">
        <div class="input-group-prepend">
          <label class="input-group-text">Titel</label>
        </div>
        <input type="text" class="form-control" v-model="document.title"/>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <label class="input-group-text">Dateiname</label>
        </div>
        <input type="text" class="form-control" v-model="document.label"/>
      </div>
      <div class="form-check-inline">
        <input id="exportFlag" type="checkbox" class="form-check-input" v-model="document.export"/>
        <label for="exportFlag">Veröffentlichen</label>
      </div>
    </div>
    <hr/>
    <div class="wrapper" style="height: 100vh; width: 100%;padding:0px;">
        <PageBuilder ref="editor" :mode="tree"/>
    </div>
    <b-modal id="compCreator" title="Komponente erstellen" ok-title="Speichern" cancel-title="Abbruch" @ok="saveHtmlComponent">
        <div class="form-group">
            <label>Name</label>
            <input type="text" v-model="component.label" class="form-control"/>
        </div>
        <div class="form-group">
            <label>Gruppe</label>
            <input type="text" v-model="component.groupName" class="form-control"/>
        </div>
    </b-modal>
  </div>
</template>

<script>
import PageBuilder from '@/components/digitalfirm/cms/PageBuilder.vue'
import cmsdocs from '@/modules/cmsdocs.js'
import router from '@/router'

export default {
  components: {
    PageBuilder,
  },
  data() {
    return {
      cmsID: 0,
      tree: false,
      catID: 0,
      comp: false,
      label: '',
      component: {
        label: '',
        groupName: '',
        locale: 'de',
        document: ''
      },
      document: {
        label: '',
      }
    }
  },
  created() {
    if (this.$route.params.docid && this.$route.params.docid !== 0) {
      this.cmsID = this.$route.params.docid;
    }
    this.tree = this.$route.params.tree;
    this.catID = this.$route.params.catid;
  },
  mounted() {
    var self = this;
    this.$refs.editor.createEditor(this.tree).then(function() {

      // check loading document or create new
      if (self.cmsID && self.cmsID > 0) {
        console.log('load page cms',self.cmsID);
        self.loadDocument();
      } else {
        console.log('create empty page');
        // init empty document meta data
        self.document.id = 0;
        self.document.title = '';
        self.document.catID = self.catID; // given cat id
        self.document.docType = 0; // default cms document
        self.document.docLink = 0;
        self.document.docTree = self.tree;
        self.document.label = '';
        self.document.locale = 'de';
        self.document.fallback = false;
        self.document.export = false;
        self.document.styles = '';
        self.document.script = '';
      }
    });

  },
  methods: {

    //
    // save document
    //
    saveDocument() {
      console.log('save cms doc');
      if (this.document.label == '') {
        this.$bvToast.toast('Bitte erst einen Namen vergeben!',{variant:'danger', title:'Dokument'});
        return;
      }
      var data = this.$refs.editor.getContent();

      console.log('save pre',this.$refs.editor.getCss(),this.$refs.editor.getHtml(),this.$refs.editor.getJs());
      if (this.document.export) {
        this.document.styles = this.$refs.editor.getCss();
        this.document.script = this.$refs.editor.getJs();
        this.document.document = this.$refs.editor.getHtml();
      } else {
        this.document.styles = '';
        this.document.script = '';
        this.document.document = '';
      }

      console.log(data);
      this.document.documentData = JSON.stringify(data);
      var self = this;
      cmsdocs.saveDocument(this.document).then(function(doc) {
        self.document = doc;
        self.$bvToast.toast('Dokument gesichert',{variant: 'success', title:'Dokument'});
      });
    },

    openDocList() {
      router.push({name: 'CMSUIManager',params: { area: this.tree }});
    },

    // speichern der aktuellen auswahl als vorlage
    createHtmlComponent() {
        console.log('test1');
        this.comp = this.$refs.editor.getSelected();

        console.log('selected',this.comp.view.$el);
        console.log('selected',this.comp.view.$el[0].outerHTML);

        if (!this.comp) {
            this.$bvToast.toast('Bitte erst ein Dokumentenbereich auswählen.',{variant:'warning',title:'Komponente'});
            return;
        }

        this.$bvModal.show('compCreator');
    },

    // speichern der komponente
    saveHtmlComponent() {
        this.comp = this.$refs.editor.getSelected();
        console.log('selected',this.comp.view.$el);
        console.log(this.comp.view.$el[0].outerHTML);

        if (!this.component.label) {
          this.$bvToast.toast('Bitte zuerst einen Namen für die Komponente eingeben.',{variant:'warning',title:'Komponente'});
          return;
        }

        if (!this.component.groupName) {
          this.$bvToast.toast('Bitte zuerst eine Gruppe/Kategorie für die Komponente eingeben.',{variant:'warning',title:'Komponente'});
          return;
        }

        var htmlcomp = {
          "id":this.component.label + '_' + this.component.groupName,
          "label":this.component.label,
          "groupName":this.component.groupName,
          "document":this.comp.view.$el[0].outerHTML,
          "locale":'de',
          "docTree":this.tree
        };

        var self = this;
        fetch('/trendshop.proxy.web/rest/cms/htmlcomponents/',{method: 'POST',credentials: 'include',body: JSON.stringify(htmlcomp)}).then(function(resp) {
          if (resp.status !== 200) {
            resp.text().then(function(text) {
              self.$bvToast.toast('Fehler beim Speichern der Komponente (' + text + ')',{variant:'error',title: 'Komponente'});
            })
          } else {
            resp.json().then(function() {
              self.$bvToast.toast('Komponente wurde gespeichert.',{variant:'success',title: 'Komponente'});
            })
          }
        }).catch(function(err) {
          self.$bvToast.toast('Fehler beim Speichern der Komponente (' + err + ')',{variant:'error',title: 'Komponente'});
        })
        console.log(htmlcomp);
    },

    //
    // load an cms document
    //
    async loadDocument() {
      var data = await cmsdocs.loadDocument(this.cmsID);
      console.log('load document:',data);
      this.document = data;
      this.$refs.editor.setContent(data);
    },

  }
}
</script>
